export const CalendarIcon = () => (
	<svg
		className='w-5 h-5 ml-3 text-gray-500 dark:text-gray-400'
		aria-hidden='true'
		xmlns='http://www.w3.org/2000/svg'
		fill='currentColor'
		viewBox='0 0 20 20'
	>
		<path d='M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z' />
	</svg>
);

export const Dot = () => (
	<svg width='8' height='8' xmlns='http://www.w3.org/2000/svg' className=' inline-block align-middle mx-2'>
		<circle cx='4' cy='4' r='4' className='bg-gray-700' />
	</svg>
);
